var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrioritiesBoard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "priorities board") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32 45.22h5.32v1.33h-2.66v2.66h2.66v1.33h-5.32v2.66h7.98v-10.64h-7.98v2.66z m2.66-23.94h2.66v-10.64h-5.32v2.66h2.66v7.98z m-2.66 7.98h4.79l-4.79 5.59v2.39h7.98v-2.66h-4.79l4.79-5.59v-2.39h-7.98v2.66z m13.3-15.96v5.32h37.24v-5.32h-37.24z m0 37.24h37.24v-5.32h-37.24v5.32z m0-15.96h37.24v-5.32h-37.24v5.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritiesBoard);
export default __webpack_public_path__ + "static/media/priorities-board.721d521beb45425ca16445cfe6fdbcdb.svg";
export { ForwardRef as ReactComponent };